import styled, { css } from 'styled-components'
import { Link } from 'react-router-dom'
import { colors, media } from 'parkway-web-common'
import { LAYOUT } from 'parkway-web-common'
import { BaseButton } from 'app/components/common/BaseButton'
import { BaseLayout } from 'app/components/common/BaseLayout'
import { SvgIconCollapsedIcon } from 'app/assets/svg-assets'

export const Slider = styled(BaseLayout.Sider)`
  position: fixed;
  overflow: visible;
  right: 0;
  z-index: 5;
  min-height: 100vh;
  max-height: 100vh;

  color: var(--text-secondary-color);
  background-color: var(--collapse-background-color);
  @media only screen and ${media.md} {
    right: unset;
    left: 0;
  }

  @media only screen and ${media.xl} {
    position: unset;
  }
`

export const CollapseButton = styled(BaseButton)<{
  $isCollapsed: boolean
}>`
  background: ${colors.white};
  border: 1px solid ${colors.white};
  transition: all 0.2s ease;
  position: absolute;
  right: -0.5rem;
  top: 3.5rem;

  ${props =>
    props.$isCollapsed &&
    css`
      right: -1rem;
    `}

  color: var(--text-secondary-color);

  &:hover {
    background: ${colors.white};
    border: 1px solid ${colors.white};
  }

  &:focus {
    background: ${colors.white};
    border: 1px solid ${colors.white};
  }
`

export const IconCollapsed = styled(SvgIconCollapsedIcon)<{
  $isCollapsed?: boolean
}>`
  transform: ${props => (props?.$isCollapsed ? 'rotate(180deg)' : '')};
`

export const SliderContent = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    background: transparent;
    width: 0px;
  }
  max-height: calc(100vh - ${LAYOUT.mobile.headerHeight});

  @media only screen and ${media.md} {
    max-height: calc(100vh - ${LAYOUT.desktop.headerHeight});
  }
`

export const SliderLogoLink = styled(Link)`
  display: flex;
  align-items: center;
  overflow: hidden;
  position: relative;
`

export const SliderLogoDiv = styled.div`
  height: ${LAYOUT.mobile.headerHeight};
  padding: ${LAYOUT.mobile.headerPadding};
  padding-right: 0rem;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media only screen and ${media.md} {
    height: ${LAYOUT.mobile.headerHeight};
    padding-top: ${LAYOUT.mobile.paddingVertical};
    padding-bottom: ${LAYOUT.mobile.paddingVertical};
  }
`

export const BrandSpan = styled.span`
  margin: 0 1rem;
  font-weight: 700;
  font-size: 1.125rem;
  color: var(--white);
`
